import { render, staticRenderFns } from "./DiscountPrice.vue?vue&type=template&id=ec7dd01e&scoped=true&"
import script from "./DiscountPrice.vue?vue&type=script&lang=ts&"
export * from "./DiscountPrice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec7dd01e",
  null
  
)

export default component.exports